import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { usePageMeta } from '../hooks/usePageMeta'

export function LoginPage() {
  usePageMeta({
    title: 'Login',
    description: 'Mitglieder-Login für BNKR.',
    canonical: '/login',
    noindex: true,
  })
  const { login, user, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const from = (location.state as { from?: string })?.from ?? '/member'

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!loading && user) navigate(from, { replace: true })
  }, [user, loading, navigate, from])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await login(email.trim(), password)
      navigate(from, { replace: true })
    } catch (err: any) {
      setError(err?.message ?? 'Login fehlgeschlagen')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="kicker crt" style={{ marginBottom: 8 }}>↳ /login · BNKR MEMBER</div>
          <div className="display" style={{ fontSize: 'clamp(32px,8vw,64px)', lineHeight: 0.9 }}>
            [<span className="crt">BNKR</span>]
          </div>
          <p className="login-sub">Member Area — Staff & Crew</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <div className="login-field">
            <label htmlFor="login-email" className="login-label">E-MAIL</label>
            <input
              id="login-email"
              type="email"
              autoComplete="email"
              required
              className="login-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="dein@email.ch"
            />
          </div>

          <div className="login-field">
            <label htmlFor="login-pw" className="login-label">PASSWORT</label>
            <input
              id="login-pw"
              type="password"
              autoComplete="current-password"
              required
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div className="login-error" role="alert">
              ✕ {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-solid-crt login-submit"
            disabled={submitting || loading}
          >
            {submitting ? 'EINLOGGEN…' : 'EINLOGGEN →'}
          </button>
        </form>

        <div className="login-footer">
          <span className="login-crt-line">▮ SECURE CONNECTION · BNKR.CH</span>
        </div>
      </div>

      <div className="crt-fx" aria-hidden />
    </div>
  )
}
